import type { FpCommonProps } from "./types";

type FpDividerProps = FpCommonProps;

/**
 * Renders `<fp-divider>`: a horizontal rule with a default colour and spacing an
 * authored style overrides. The rule keeps any class its caller injects, such as
 * the editor's hidden-block marker.
 * @param props - The container style and any class
 * @returns The rule
 */
export function FpDivider({
  className,
  style,
  "data-fp-node": dataFpNode,
}: FpDividerProps) {
  return (
    <hr
      className={className}
      style={{
        border: "none",
        borderTop: "1px solid #d1d5db",
        margin: "8px 0",
        ...style,
      }}
      data-fp-node={dataFpNode}
    />
  );
}
